module.exports = __webpack_public_path__ + "img/cover.9a347f5e.svg";